// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section {
  display: inline-block;
}

svg {
  height: 120px;
  width: 100%;
}

.noteText, .syllableText {
  white-space: nowrap;
  text-align: left;
  border: 1px dashed gray;
  margin: 5px;
  font-family: "Times New Roman", Times, serif;
  font-size: 16px;
  visibility: hidden;
  line-height: 25px;
  height: 25px;
}

svg .note {
  cursor: pointer;
}

.read-only .noteText {
  display: none;
}
.read-only .syllableText {
  border: none;
}
.read-only svg {
  height: 90px;
}`, "",{"version":3,"sources":["webpack://./src/app/line-change/line-change.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;;AAEA;EACI,aAAA;EACA,WAAA;AACJ;;AAEA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,4CAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAGI;EAAY,aAAA;AAChB;AAAI;EAAgB,YAAA;AAGpB;AAFI;EAAM,YAAA;AAKV","sourcesContent":[".section {\n    display: inline-block;\n}\n\nsvg {\n    height: 120px;\n    width: 100%;\n}\n\n.noteText, .syllableText {\n    white-space: nowrap;\n    text-align: left;\n    border: 1px dashed gray;\n    margin: 5px;\n    font-family: \"Times New Roman\", Times, serif;\n    font-size: 16px;\n    visibility: hidden;\n    line-height: 25px;\n    height: 25px;\n}\n\nsvg .note {\n    cursor: pointer;\n}\n\n.read-only {\n    .noteText { display: none; }\n    .syllableText { border: none; }\n    svg { height: 90px; }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
